import { z, uuidSchema } from '@kc3/validation';
import { baseEventFields } from './_base.js';
export const RecordingEncryptEventSchema = z.object({
    type: z.literal('recording.encrypt'),
    ...baseEventFields,
    recordingId: uuidSchema,
    callId: uuidSchema,
    sourcePath: z.string().min(1),
});
export const RecordingEncryptedEventSchema = z.object({
    type: z.literal('recording.encrypted'),
    ...baseEventFields,
    recordingId: uuidSchema,
    callId: uuidSchema,
    encryptedPath: z.string().min(1),
    dekId: uuidSchema,
    sizeBytes: z.number().int().nonnegative(),
});
//# sourceMappingURL=recording.js.map